export default __webpack_public_path__ + "static/media/Hana_Pharmacy_Guide.c02db375.pdf";